//-================ IMPORTS FOR GENERAL COMPONENT ================-\\
import { Component } from '@angular/core';
import { OnDestroy, OnInit, inject } from '@angular/core';
import { Subscription } from 'rxjs';

//-================ IMPORTS FOR SERVICES ================-\\

//-================ IMPORTS FOR CONSTANTS ================-\\

//-================ IMPORTS FOR DEPENDENCIES ================-\\

//-================ IMPORTS FOR INTERFACES ================-\\
import { CARD_ADMIN } from 'src/app/Interfaces/Admin/Administrator_General.inferface';
import { UserDataService } from 'src/app/Services/Authentication/User/user-data.service';

@Component({
    selector: 'app-administrator-cdms',
    templateUrl: './administrator-cdms.component.html',
    styleUrls: ['./administrator-cdms.component.scss', '../../../Styles/GlobalStyles.css'],
    standalone: false
})
export class AdministratorCDMSComponent implements OnInit, OnDestroy {

  private UserService = inject(UserDataService);

  constructor() { }

  //+================== VARIABLES FOR CARDS ADMINISTRATOR ==================+\\
  private AllAdministratorBase: CARD_ADMIN[] = [
    { Title: 'Usuarios', Description: 'puede crear, modificar o eliminar un usuario del sistema.', ButtonText: 'Ver usuarios', RouteLink: '/Dashboard/Admin/AdminUsersCDMS', Icon: 'fa-users', IconButton: 'fa-user' },
    { Title: 'Roles de sistema', Description: 'puede crear, modificar o eliminar roles en cada libreria del sistema.', ButtonText: 'Ver roles', RouteLink: '/Dashboard/Admin/MenuGeneralRol', Icon: 'fa-shield-halved', IconButton: 'fa-shield-halved' },
    { Title: 'Grupos / Permisos', Description: 'puede crear, modificar o eliminar un grupo de sistema.', ButtonText: 'Ver grupos', RouteLink: '/Dashboard/Admin/AdminGroupCDMS', Icon: 'fa-people-group', IconButton: 'fa-user-group' },
    { Title: 'Cabeceras', Description: 'puede modificar las cabeceras de las librerías del sistema.', ButtonText: 'Ver cabeceras', RouteLink: '/Dashboard/Admin/AdminHeadersLB', Icon: 'fa-heading', IconButton: 'fa-newspaper' },
    { Title: 'Reportes Generales', Description: 'puede consultar los reportes generales del sistema.', ButtonText: 'Ver reportes', RouteLink: '/DashboardAdmin/', Icon: 'fa-chart-pie', IconButton: 'fa-chart-simple' }
  ]

  public AllAdministrator: CARD_ADMIN[] = [];
  private UserDataSub?: Subscription;

  ngOnInit(): void {
    this.UserDataSub = this.UserService.GetDataUser.subscribe(() => {
      this.BuildAdministratorCards();
    });

    // Reforzar refresco cuando se entra directo por URL (F5) y el estado en memoria esta vacio.
    this.UserService.RefrestDataUser();
  }

  ngOnDestroy(): void {
    this.UserDataSub?.unsubscribe();
  }

  private BuildAdministratorCards(): void {
    const roles = this.UserService.SharingDataUser.value.Role.map((role: string) => String(role || '').toUpperCase());
    const isSuperAdmin = this.UserService.IsSuperAdministrator();
    const hasAnyAdministratorScope = isSuperAdmin || roles.some((role: string) => role.startsWith('ADMINISTRATOR'));
    const hasAnyReportsScope = isSuperAdmin || roles.some((role: string) => role.startsWith('REPORTS'));

    this.AllAdministrator = this.AllAdministratorBase.filter((card) => {
      if (card.RouteLink === '/Dashboard/Admin/AdminUsersCDMS') {
        return hasAnyAdministratorScope;
      }

      if (card.RouteLink === '/Dashboard/Admin/MenuGeneralRol') {
        return hasAnyAdministratorScope;
      }

      if (card.RouteLink === '/Dashboard/Admin/AdminGroupCDMS') {
        return hasAnyAdministratorScope;
      }

      if (card.RouteLink === '/Dashboard/Admin/AdminHeadersLB') {
        return hasAnyAdministratorScope;
      }

      if (card.RouteLink === '/DashboardAdmin/') {
        return hasAnyReportsScope || hasAnyAdministratorScope;
      }

      return isSuperAdmin;
    });
  }


  //&===================== FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  //-================== FUNCTTION FOR GREETTING ==================-\\
  public GetGreeting(): string {

    let TextGTings: string = '';

    const Date_User = new Date();
    const Hour = Date_User.getHours();

    if (Hour >= 0 && Hour <= 5) {
      TextGTings = 'Buenas noches';
    } else if (Hour >= 6 && Hour <= 11) {
      TextGTings = 'Buenos días';
    } else if (Hour >= 12 && Hour <= 17) {
      TextGTings = 'Buenas tardes';
    } else if (Hour >= 18) {
      TextGTings = 'Buenas noches';
    }

    return TextGTings;
  }

  //-================ FUNCTION FOR NAME USER ================-\\
  public NameUser(): string {
    const Name_User: string = localStorage.getItem('Name_User') || "";
    return (Name_User.split(' ', 2)).join(' ');
  }

  //&===================== END FUNCTIONS FOR GENERAL COMPONENT =====================&\\

}
